import React, {Fragment, useEffect} from "react";
import HomePricingCSS from "./HomePricing.module.scss";
import HomePricingCard from "./HomePricingCard";
import {Button} from "antd";
import {actions as plansActions} from "../../reducers/plans";
import {useDispatch, useSelector} from "react-redux";
import Loader from "components/common/PageLoader";

const HomePricing = ({setisContactOpen}) => {
  const dispatch = useDispatch();
  const {data, ids, isLoading} = useSelector((state) => state.plans);
  useEffect(() => {
    dispatch(plansActions.onRequest({}));
    return () => {};
    // eslint-disable-next-line
  }, []);
  if (isLoading) {
    return <Loader />;
  }
  return (
    <Fragment>
      <div className={HomePricingCSS.HomePricing}>
        <div className={`container ${HomePricingCSS.HomePricing_container}`}>
          <div>
            <h3 className={HomePricingCSS.HomePricing_title}>
              eVideo and eTherapy with ADDVantage Minds
            </h3>
            <p className={HomePricingCSS.HomePricing_desc}>
              Don't miss the opportunity to meet your patient's need. <br />
              Maximize the capabilities of remote consultation and counselling,
              and provide to your patients wherever they are
            </p>
          </div>
          <div className={HomePricingCSS.PricingCardWrapper}>
            {ids
              .slice(0, 3)
              .reverse()
              .map((id, index) => {
                return (
                  <HomePricingCard key={id} labelKey={index} data={data[id]} />
                );
              })}
            {/* static pricing card */}
            <div className={HomePricingCSS.PricingCard}>
              <div className={HomePricingCSS.PricingCard_heading}>
                <h4 className={HomePricingCSS.PricingCard_title}>
                  Healthcare Organization
                </h4>
                <p className={HomePricingCSS.PricingCard_desc}>
                  For Mental Health Providers
                </p>
              </div>
              <div className={HomePricingCSS.PricingCard_price_wrapper}>
                <h4>Fee</h4>
                <span>per consultation</span>
              </div>
              <div className={HomePricingCSS.PricingCard_plandesc}>
                <ul>
                  <li>Flexi-charge per clinician per month</li>
                  <li>Flexi-charge per clinician per consultation</li>
                </ul>
              </div>
              <div className={HomePricingCSS.PricingCard_button}>
                <Button
                  type="primary"
                  className="btn-primary btn medium-btn text-capitalize"
                  onClick={() => setisContactOpen(true)}
                >
                  Contact Us
                </Button>
              </div>
            </div>
            {/* static pricing card */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default HomePricing;
